import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const PanePointerStart = Schema.Struct({ pointerId: Schema.Number, button: Schema.Number, primary: Schema.Boolean, collapsed: Schema.Boolean });
export type PanePointerStart = typeof PanePointerStart.Type;
export const PanePointerMove = Schema.Struct({ pointerId: Schema.Number, collapsed: Schema.Boolean, vertical: Schema.Boolean, client: Schema.Number, min: Schema.Number, max: Schema.Number });
export type PanePointerMove = typeof PanePointerMove.Type;
export class PanePointerFailure extends privateDependencyFailure<PanePointerFailure>()("PanePointerFailure", "pane pointer") {}
export const panePointerFailure = (cause: unknown) => new PanePointerFailure({ cause: Redacted.make(cause) });
